/*
**************************** 
홈페이지 톡톡 플러스+ (수학)
*****************************
*/

import React from "react";

export default function Math(props) {

    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">고객센터</a></li>
                    <li className="breadcrumb-item active small">FAQ</li>
                </ol>
            </div>

            <ul className="nav nav-tabs d-flex justify-content-center" role="tablist">
                <li className="nav-item medium" role="presentation">
                    <a className="nav-link active text-black text-decoration-none" data-bs-toggle="tab" href="#hodoo123" aria-selected="true" role="tab" tabIndex="-1">호두123</a>
                </li>
            </ul>
            <div className="container mt-3">
                <div id="myTabContent" className="tab-content">
                    <div className="tab-pane  active show" id="hodoo123" role="tabpanel">
                        <div className="container-custom w-100">
                            <img className="img-fluid" src="/img/school/hodoo123.jpg"></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}